$(document).ready(function(){
  $('.template-page-subscription [data-categories] select').each(function(){
    $(this).find('option:first').hide();
  });
  
  let selectedGender = $('[data-gender-categories] a.active').data('gender');

  var current_fs, next_fs, previous_fs; //fieldsets
  var left, opacity, scale; //fieldset properties which we will animate
  var animating; //flag to prevent quick multi-click glitches
  let subscriptionIndexPage = true;
  let currentFormPageIndex = 0;
  let shirtSize = null;
  let shortSize = null;
  let birthday = '';
  let tShirtVar = '';
  let ShortVar = '';
  let FinalVar = '';
  let productId;
  let variantData = null;

  let subscribe_form = $(".subscribe-form fieldset");

  // move progress bar
  $(document).on('click', '[data-progress-bar] .active', function(e){ 
    let currentClick = this.dataset.option;
    // $(".template-page-subscription fieldset").hide();
    $("."+currentClick).show();
    $("."+currentClick).css({"opacity" : "1", "transform" : "unset"});
    setTimeout(function(){
           document.querySelector("."+currentClick).scrollIntoView({behavior: "smooth"});
    },100);
  });
  
  //this is used for choose male or female tabify gender
  $(document).on('click','[data-gender-categories] a',function(e){
  	e.preventDefault();
    $(this).parents("fieldset").find("[data-next]").prop("disabled","disabled");
    selectedGender = $(this).data('gender');
    $('[data-gender-categories] a').removeClass('active');
    $('[data-toggle]').addClass('d-none').removeClass('d-flex');
    $(this).addClass('active');
    $(`[${$(this).data('target')}]`).removeClass('d-none').addClass('d-flex');
  });
  
  // get properties from downdown choose option
  $(document).on('change', '[data-categories] select, [data-categories] input', function(e){ 
    if(selectedGender == 'men'){
      shirtSize = $('#select_shirt_size_men').val();
      shortSize = $('#select_short_size_men').val();
      birthday = $('#birthday_men').val();
    } else if (selectedGender == 'women'){
      shirtSize = $('#select_shirt_size_women').val();
      shortSize = $('#select_short_size_women').val();
      birthday = $('#birthday_women').val();
    }
    if($(e.target).attr('id').includes('select_shirt_size')){
    	tShirtVar = $(e.target).find(':selected').text().trim();
    }
    if($(e.target).attr('id').includes('select_short_size')){
    	ShortVar = $(e.target).find(':selected').text().trim();
    }
    
    if(shirtSize != null && shortSize != null && birthday != '' )
    {
      $(".single-flow-add-to-cart").find("[data-add-to-cart]").prop("disabled",false);
      FinalVar = tShirtVar + ' / ' + ShortVar;
      if(FinalVar!="")
      {
        $('input[data-plans]:checked').trigger('change');
      }
    }
    else
    {
      $(".single-flow-add-to-cart").find("[data-add-to-cart]").prop("disabled","disabled");
      FinalVar = '';
    }
    
  });
  
  //this is used for scroll down each step
  $("[data-next]").click(function(){ // move to next step
    
    let parent = false;
    if(animating) return false;
    animating = true;
    subscriptionIndexPage = false;
    currentFormPageIndex += 1;

    current_fs = $(this).closest("fieldset");
    next_fs = current_fs.next();
    
    //activate next step on progressbar using the index of next_fs
    
    if($("[data-progress-bar] li").eq($("fieldset").index(next_fs)).length > 0)
    { 
        if($("fieldset").index(next_fs) == 2) 
        {
          
          $('input[data-plans]:checked').trigger('change');
          
          setTimeout(function(){
           document.querySelector(".fieldset-3").scrollIntoView({behavior: "smooth"});
          },1000);
        }
        else if($("fieldset").index(next_fs) == 1)
        {
          setTimeout(function(){
           document.querySelector(".fieldset-2").scrollIntoView({behavior: "smooth"});
          },1000);
        }
        
        $("[data-progress-bar] li").eq(($("fieldset").index(next_fs) -1)).addClass("active done");
        $("[data-progress-bar] li").eq($("fieldset").index(next_fs)).addClass("active");
    
    }
    else
    {
      $($("[data-progress-bar] li")[1]).addClass("active done");
      $($("[data-progress-bar] li")[2]).addClass("active");
    }
    
    //hide the current fieldset with style
    current_fs.animate({opacity: 1}, {
      step: function(now, mx) {
        //as the opacity of current_fs reduces to 0 - stored in "now"
        //1. scale current_fs down to 80%
        scale = 1 - (1 - now) * 0.2;
        //3. increase opacity of next_fs to 1 as it moves in
        opacity = 1;
        current_fs.css({'transform': 'scale('+scale+')'});
        next_fs.css({'opacity': opacity});
      }, 
      duration: 500, 
      complete: function(){
        current_fs.show();
        next_fs.show(); 
        animating = false;
      }, 
      //this comes from the custom easing plugin
      easing: 'easeInOutBack'
    });
    
  });
  
  // select active product
  $(document).on('change', 'input[data-plans]', (e)=>{
  	let currentValue = e.target.value;
    productId = e.target.dataset.productId;
    if(FinalVar=='')
    {
      alert('Please Choose Size and Age');
      return false;
    }
    variantData = $('[data-product-data][data-title="'+FinalVar+'"][data-prd-id='+productId+']');
    
    $('[data-gifting-div]').removeClass('active').hide();
    
    console.log("USA Products");
    
    let startdate = e.target.dataset.black_friday_start_date;
    let enddate = e.target.dataset.black_friday_end_date;
    let discountcode = e.target.dataset.black_friday_discount_code;
    let discountamount = e.target.dataset.black_friday_discount_amount;

    if(startdate != '')
    {
      $('input[name="properties[black_friday_start_date]"]').val(startdate);
    }
    else
    {
      $('input[name="properties[black_friday_start_date]"]').val('');
    }
    
    if(enddate != '')
    {
      $('input[name="properties[black_friday_end_date]"]').val(enddate);
    }
    else
    {
      $('input[name="properties[black_friday_end_date]"]').val('');
    }

    if(discountcode != '')
    {
      $('input[name="properties[black_friday_discount_code]"]').val(discountcode);
    }
    else
    {
      $('input[name="properties[black_friday_discount_code]"]').val('');
    }

    if(discountamount != '')
    {
      $('input[name="properties[black_friday_discount_amount]"]').val(discountamount);
    }
    else
    {
      $('input[name="properties[black_friday_discount_amount]"]').val('');
    }

    $('[data-gift-main-prd="'+productId+'"]').addClass('active').show();

    if(variantData != undefined) {
      variantData = JSON.parse($(variantData).html().trim());
    }
    //document.querySelector("fieldset [data-add-to-cart]").scrollIntoView({behavior: "smooth"});
    let newprice = $('.real-crate-subtotal[data-product-id="'+productId+'"]').text();
    $('.crate-subtotal').text(newprice);
  });

  //add to cart click event
  $(document).on('click', '.single-flow-add-to-cart [data-add-to-cart]', (e)=>{
  	e.preventDefault();
    e.stopPropagation();
    
    const prop = prepareProperties();
    const cartItems = prepareCartItems(prop,variantData); 

    // this is used for clear cart api
    $.ajax({
      type: 'POST',
      url: '/cart/clear.js',
      success: function() {

        if($('[data-gifting-div].active').length){
            // only add gifting if gift product exists
            const giftingVar = $('[data-gifting-div].active').data('giftVarId');
            const mainPrdProp = $('[data-gifting-div].active').data('mainPrdAutoRenewId');
            const data = {
              items: [{
                id: giftingVar,
                quantity: 1,
                properties: {
                  '_main_product_id': mainPrdProp
                }
              }]
            };
          
            $.ajax({
              type: 'POST',
              data: data,
              url: '/cart/add.js',
              dataType: 'json',
              success: function() {
                AddtoCart(cartItems);
              }
            });  
          } 
          else 
          {
            AddtoCart(cartItems);
          }
      },
      dataType: 'json'
    });
  });

  function AddtoCart(cartItems){
    $.ajax({
      url: '/cart/add.js',
      type: 'POST',
      dataType: 'json',
      data: JSON.stringify(cartItems), 
      contentType: "application/json",
    }).then(function(response) {            
        window.location.href = '/cart';
    })
  }
  
});

function prepareProperties() {
  let prop = {};
	$.each($('[name*="properties"]').serializeArray(), function() {
      if(this.value != ''){
        const name = this.name.replace('properties[', '').replace(']', '');
        prop[name] = this.value;
      }
    });
  return prop;
}// function closed

function prepareCartItems(prop,variantData ) {
  let items  = [];

  let mainProduct = {
    quantity:1,
    id: variantData.id,
    selling_plan: parseInt(variantData.selling_plan_allocations[0].selling_plan_id),
    properties: prop,          
  }  

  items.push(mainProduct);

  return {
    items: items
    };

}// function closed